import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import {Fade} from "react-awesome-reveal";
import {isIOS, isPc, savePageVisit} from "../static/js/common";
import {useEffect, useState} from "react";

import { useAnimate, AnimateKeyframes } from "react-simple-animate";
import {TypeAnimation} from "react-type-animation";

const DisappearTags = ({}) => {

  const allTags = ['EXPERIENTIAL MARKETING', 'PROMOTIONS', 'BRAND GOODS', 'SPACE MARKETING', 'MEDIA SERVICE', 'BRAND CONTENT', 'SOCIAL MEDIA CAMPAIGN', 'BRAND STORYTELLING', 'INTERACTIVE CONTENT']
  const [tags, setTags] = useState(allTags)

  // const [miliseconds, setMiliSeconds] = useState(0)

  // const { play, style, isPlaying } = useAnimate({
  //   start: { transform: "translateX(800px)" },
  //   end: { transform: "translateX(0px)" },
  //   duration: 3,
  // });
  //
  // useEffect(() => {
  //   setTimeout(() => play(!isPlaying), 3000)
  //
  //   if(!isPlaying) {
  //
  //   } else {
  //     tags.shift()
  //     setTags(tags)
  //   }
  //
  // }, [isPlaying])

  // useEffect(() => {
  //   setTimeout(() => setMiliSeconds(miliseconds + 100), 100)
  // }, [miliseconds]);

  return (
    <div className={'flex-row'}>
      <img style={{width: 223, zIndex: 2}} src={require('../assets/images/service/BX.png')}/>
        {/*<div className={'margin-left-20 flex-row'} style={style}>*/}
      <div className={'relative'} style={{marginLeft: 20, zIndex: 0, overflow: 'hidden'}}>
        <section className={'banner-section disappear'} style={{"--speed": `${50000}ms`}}>
            {tags?.map((item, index) => {
              return (
                <div key={`tag-${index}`} className={'white bebas-kai nowrap'} style={{fontSize: 90, marginRight: 50, opacity: 1}}>{item}</div>
              )
            })}
        </section>
      </div>
        {/*</div>*/}
    </div>
  )
}

const Tags = ({}) => {

  const allTags = ['EXPERIENTIAL MARKETING', 'PROMOTIONS', 'BRAND GOODS', 'SPACE MARKETING', 'MEDIA SERVICE', 'BRAND CONTENT', 'SOCIAL MEDIA CAMPAIGN', 'BRAND STORYTELLING', 'INTERACTIVE CONTENT']
  const [tags, setTags] = useState(allTags)
  const [index_, setIndex_] = useState(0);

  useEffect(() => {
    if(isPc) {
      if(index_ === 0) {
        setTimeout(() => setIndex_(index_ + 1), 3000)
      } else if ((index_ + 1) === allTags?.length){
        setTimeout(() => setIndex_( 0), 3000 * 2)
      } else {
        setTimeout(() => setIndex_( index_ + 1), 3000)
      }
    }
  }, [index_]);

  return (
    <div className={'flex-row'}>
      <div className={'flex-column'} style={{marginLeft: 620}}>
        <section className={'banner-forward-section'} style={{"--speed": `${35000}ms`}}>
          {tags?.map((item, index) => {
              return (
                <div className={'flex-column'} style={{marginRight: 24}}>
                <div className={'white bebas-kai nowrap service-animation-text'}
                     style={{marginRight: '1rem', opacity: 0.3}}>{item}</div>
                </div>
              )
            })}
        </section>
        <section className={'banner-section'} style={{"--speed": `${30000}ms`}}>
          {tags?.map((item, index) => {
            const isActive = index === index_;

            return (
              <div className={'flex-column'} style={{marginRight: 24}}>
                {isActive && isPc ?
                  <TypeAnimation
                    className={'white bebas-kai nowrap service-animation-text'}
                    sequence={[
                      // Same substring at the start will only be typed out once, initially
                      item[0], 1000,
                      item,
                      1000
                    ]}
                    wrapper="span"
                    speed={50}
                    style={{display: 'inline-block'}}
                    repeat={false}
                    preRenderFirstString={false}
                  />
                  :
                  <div className={'white bebas-kai nowrap service-animation-text'}
                       style={{marginRight: '1rem', opacity: 0.3}}>{item}</div>
                }
              </div>
            )
          })}
          </section>
          <section className={'banner-forward-section'} style={{"--speed": `${25000}ms`}}>
            {tags?.map((item, index) => {
              return (
                <div className={'flex-column'} style={{marginRight: 24}}>
                <div className={'white bebas-kai nowrap service-animation-text'}
                     style={{marginRight: '1rem', opacity: 0.3}}>{item}</div>
                </div>
              )
            })}
          </section>
      </div>
    </div>
)
}

export const Service = ({}) => {

  useEffect(() => {
    savePageVisit('Service')
    window.scroll(0, 0)
  }, [])

  return (
    <div>
      <Header/>
      {isPc ?
      <div>
        <div className={'relative'}>
          <video playsInline autoPlay muted loop className={'width-100 height-100-vh'} style={{objectFit: 'cover'}} src={require('../assets/videos/02_w_sub_service_01.mp4')}/>
        </div>

        <div className={'relative'} style={{marginTop: -5}}>./
          <img className={'width-100'} src={require('../assets/images/service2_bg_.png')}/>
          <div className={'absolute'} style={{left: 0, top: 0}}>
            <Fade direction={'left'}>
              <img style={{width: '30vw'}} src={require('../assets/images/service_red.png')}/>
            </Fade>
          </div>
          <div className={'absolute'} style={{left: '38vw', top: '8vw'}}>
            <Fade direction={'right'}>
              {/*<img style={{width: '40vw'}} src={require('../assets/images/service2_text.png')}/>*/}
              <div className={'title white bebas-kai no-letter-spacing'} style={{lineHeight: '13vw'}}><span className={'gray8'}>B</span>RAND<br/>E<span className={'gray8'}>X</span>PERIENCES</div>
            </Fade>
          </div>
          {/*<div className={'absolute'} style={{left: '50vw', top: '34.4vw'}}>*/}
          {/*  <Fade direction={'right'}>*/}
          {/*    <img style={{width: '5vw'}} src={require('../assets/images/line.png')}/>*/}
          {/*  </Fade>*/}
          {/*</div>*/}
          <div className={'absolute'} style={{left: '38vw', top: '40vw'}}>
            <Fade direction={'right'}>
              <div className={'notosans-regular white font-1_4vw'} style={{lineHeight: 1.8}}>
                휘닉스커뮤니케이션즈 Brand eXperiences 의 아이디어에 제한된 영역은 없습니다.<br/>
                다양한 브랜드 콘텐츠부터 소비자 경험 마케팅, 디지털 캠페인, 미디어서비스까지<br/>
                브랜드 성공을 위해 경계를 넘나드는 통합된 캠페인을 실행합니다.
              </div>
            </Fade>
          </div>
        </div>

        <div className={'relative black-bg'} style={{marginTop: -5, marginBottom: -5}}>
          <img className={'width-100'} src={require('../assets/images/service3_bg.png')}/>
          <div className={'absolute flex-column width-100'} style={{top: '5vw', left: '3vw'}}>
            <Fade direction={'left'}>
              {/*<img style={{width: '40vw'}} src={require('../assets/images/creactor.png')}/>*/}
              <div className={'bebas-kai title white no-letter-spacing'}>CREACTOR</div>
              {/*<img style={{width: '6vw', marginTop: '5vw', marginBottom: '5vw'}} src={require('../assets/images/gray_line.png')}/>*/}
              <div className={'notosans-regular white text-left font-1_4vw'} style={{lineHeight: 1.8, marginTop: '4vw'}}>
                create 와 actor 의 합성어인 CREACTOR 는<br/>
                브랜드를 위해 언제나 새로운 생각과 아이디어를<br/>
                창조하고 행동하는 휘닉스커뮤니케이션즈의<br/>
                아이덴티티를 상징합니다.
              </div>
            </Fade>
          </div>
          {/*<div className={'absolute flex-end'} style={{top: '12vw', right: '20vw'}}>*/}
          {/*  <img style={{width: '2.2vw'}} src={require('../assets/images/vertical_logo.png')}/>*/}
          {/*</div>*/}
          {/*<div className={'absolute flex-end'} style={{bottom: 5, right: 0}}>*/}
          {/*  <Fade direction={'right'}>*/}
          {/*    <img style={{width: '20vw'}} src={require('../assets/images/service2_x.png')}/>*/}
          {/*  </Fade>*/}
          {/*</div>*/}
        </div>

        <div className={'relative white-bg'}>
          <img className={'width-100'} src={require('../assets/images/service3_2_bg.png')}/>
          <div className={'absolute'} style={{top: '6vw', right: '10vw'}} align={'right'}>
            <Fade direction={'right'}>
              {/*<img style={{height: '22vw'}} src={require('../assets/images/service3_text1.png')}/>*/}
              <div className={'bebas-kai title no-letter-spacing red'}>BRAND<br/>PLANNING</div>
              <div className={'notosans-bold text-right font-2_4vw'} style={{marginTop: '3vw'}}>
                휘닉스커뮤니케이션즈의 모든 서비스의 시작점은 브랜드입니다.
              </div>
              <div className={'notosans-regular text-right margin-top-20 font-1_4vw'}>
                브랜드의 비전과 목표를 기반으로 시장과 소비자에 대한 깊은 이해와 경험,<br/>
                통찰력을 통해 브랜드의 당면과제를 파악하고 이를 해결할 수 있는<br/>
                가장 효과적인 커뮤니케이션 전략을 제공합니다.
              </div>
            </Fade>
          </div>
          <div className={'absolute'} style={{top: '58vw', left: '10vw'}}>
            <Fade direction={'left'}>
              {/*<img style={{height: '22vw'}} src={require('../assets/images/service3_text2.png')}/>*/}
              <div className={'bebas-kai title no-letter-spacing red'}>BRAND<br/>CONTENT</div>
              <div className={'notosans-bold text-left font-2_4vw'} style={{marginTop: '3vw'}}>
                휘닉스커뮤니케이션즈의 크리에이티브는<br/>
                단순히 광고에 머물지 않습니다.
              </div>
              <div className={'notosans-regular text-left margin-top-20 font-1_4vw'}>
                브랜드의 상황과 전략, 그리고 타겟 소비자의 라이프스타일과 트렌드에<br/>
                기반하여 최적의 접점에서 소비자의 주목을 끌고 생각과 행동을 바꾸는<br/>
                다양한 브랜드 콘텐츠를 만들어냅니다.
              </div>
            </Fade>
          </div>
          <div className={'absolute'} style={{top: '108vw', right: '10vw'}} align={'right'}>
            <Fade direction={'right'}>
              {/*<img style={{height: '22vw'}} src={require('../assets/images/service3_text3.png')}/>*/}
              <div className={'bebas-kai title no-letter-spacing red'}>BRAND<br/>ACTIVATION</div>
              <div className={'notosans-bold text-right font-2_4vw'} style={{marginTop: '3vw'}}>
                휘닉스커뮤니케이션즈의 모든 커뮤니케이션은<br/>
                소비자와의 긴밀한 관계 구축을 지향합니다.
              </div>
              <div className={'notosans-regular text-right margin-top-20 font-1_4vw'}>
                광고를 통해 브랜드를 알리는 것에서 더 나아가, 소비자가 브랜드를 직접 체험하고 브랜드와 유대감을 형성하게<br/>
                하는 다양한 활동들을 전개하여 즉각적인 행동 유발과<br/>
                함께 중장기적으로 브랜드에 대한 충성도를 강화합니다.
              </div>
            </Fade>
          </div>
          <div className={'absolute'} style={{top: '158vw', left: '10vw'}}>
            <Fade direction={'left'}>
              {/*<img style={{height: '22vw'}} src={require('../assets/images/service3_text4.png')}/>*/}
              <div className={'bebas-kai title no-letter-spacing red'}>BRAND<br/>INNOVATION</div>
              <div className={'notosans-bold text-left font-2_4vw'} style={{marginTop: '3vw'}}>
                휘닉스커뮤니케이션즈의 솔루션은<br/>
                늘 새로움을 추구합니다.
              </div>
              <div className={'notosans-regular text-left margin-top-20 font-1_4vw'}>
                익숙한 광고 기술보다 혁신적인 광고 기술로 새로운 형태의 브랜드 콘텐츠를 만들어내고,<br/>
                변화하는 미디어 환경과 시대적인 소비자의 선호에 맞춰 데이터 기반의 효율적인 커뮤니케이션을 실행합니다.
              </div>
            </Fade>
          </div>
        </div>

        <div className={'relative'} style={{marginTop: -5}}>
          <img className={'width-100'} src={require('../assets/images/service4_bg.png')}/>
          <div className={'absolute'} style={{top: '8vw', left: '5vw'}}>
            <Fade direction={'left'}>
              {/*<img style={{width: '85vw'}} src={require('../assets/images/service4_text.png')}/>*/}
              <div className={'bebas-kai white title no-letter-spacing'} style={{lineHeight: '14vw'}}><span className={'red'}>I</span>NTEGRATED<br/><span className={'red'}>B</span>RAND<br/>E<span className={'red'}>X</span>PERIENCE</div>
              <div className={'white font-1_4vw notosans-regular margin-top-62'}>
                <span className={'notosans-bold'}>휘닉스커뮤니케이션즈의 크리에이티브에는 제한된 영역은 없습니다.</span><br/><br/>
                브랜드 콘텐츠부터 소비자 경험 마케팅, 디지털 캠페인에 미디어 서비스까지<br/>
                브랜드 성공을 위해 경계를 넘나들며 다양하면서도 통합된 캠페인을 실행합니다.
              </div>
            </Fade>
          </div>
          {/*<div className={'absolute'} style={{top: '0vw', right: '0vw'}} align={'right'}>*/}
          {/*  <Fade direction={'right'}>*/}
          {/*    <img style={{width: '30%'}} src={require('../assets/images/service4_x.png')}/>*/}
          {/*  </Fade>*/}
          {/*</div>*/}
          <div className={'absolute'} style={{bottom: '12vw', left: '1.5vw'}} align={'right'}>
            {/*<Fade direction={'up'}>*/}
            {/*  <img style={{width: '90vw'}} src={require('../assets/images/service4_tags.png')}/>*/}
            {/*</Fade>*/}

            <Tags/>
            {/*<DisappearTags/>*/}

          </div>
        </div>
      </div>
        :
        <div>
          <video playsInline autoPlay muted loop className={'width-100'}
                 style={{objectFit: 'cover', height: `calc(100vh - ${isIOS() ? '80px' : '40px'})`}}
                 src={require('../assets/videos/02_m_sub_service_01.mp4')}/>
          <div className={'relative'} style={{marginTop: -5}}>
            <img className={'width-100'} style={{marginBottom: -70}} src={require('../assets/images/mobile/mobile_service_2_.png')}/>
            <div className={'absolute'} style={{top: '68vw', right: '7vw'}}>
              <Fade direction={'right'}>
                <img style={{width: '80vw'}} src={require('../assets/images/mobile/service2_text.png')}/>
              </Fade>
            </div>
          </div>

          <div className={'relative'} style={{marginTop: -12, marginBottom: -5}}>
            <img className={'width-100'} src={require('../assets/images/mobile/service3_bg.png')}/>
            <div className={'absolute flex-column width-100'} style={{top: '10vw', left: '3vw'}}>
              <Fade direction={'left'}>
                <img style={{width: '50vw'}} src={require('../assets/images/creactor.png')}/>
                {/*<img style={{width: '6vw', marginTop: '5vw', marginBottom: '5vw'}} src={require('../assets/images/gray_line.png')}/>*/}
                <div className={'notosans-regular white text-left font-12'}
                     style={{lineHeight: 1.8, marginTop: '6vw'}}>
                  create 와 actor 의 합성어인 CREACTOR 는<br/>
                  브랜드를 위해 언제나 새로운 생각과 아이디어를<br/>
                  창조하고 행동하는 휘닉스커뮤니케이션즈의<br/>
                  아이덴티티를 상징합니다.
                </div>
              </Fade>
            </div>
          </div>

          <div className={'relative white-bg'} style={{marginTop: -5}}>
            <img className={'width-100'} style={{marginBottom: -110}} src={require('../assets/images/mobile/mobile_service_4_bg.png')}/>
            <div className={'absolute'} style={{top: '40vw', right: '5vw'}} align={'right'}>
              <Fade direction={'right'}>
                <img style={{height: '40vw'}} src={require('../assets/images/service3_text1.png')}/>
                <div className={'notosans-bold font-18 text-right'} style={{marginTop: '3vw'}}>
                  휘닉스커뮤니케이션즈의 모든 서비스의<br/>
                  시작점은 브랜드입니다
                </div>
                <div className={'notosans-regular font-12 text-right margin-top-20'}>
                  브랜드의 비전과 목표를 기반으로<br/>
                  시장과 소비자에 대한 깊은 이해와 경험, 통찰력을 통해<br/>
                  브랜드의 당면과제를 파악하고 이를 해결할 수 있는<br/>
                  가장 효과적인 커뮤니케이션 전략을 제공합니다.
                </div>
              </Fade>
            </div>
            <div className={'absolute'} style={{top: '160vw', left: '5vw'}}>
              <Fade direction={'left'}>
                <img style={{height: '40vw'}} src={require('../assets/images/service3_text2.png')}/>
                <div className={'notosans-bold font-18 text-left'} style={{marginTop: '3vw'}}>
                  휘닉스커뮤니케이션즈의 크리에이티브는<br/>
                  단순히 광고에 머물지 않습니다.
                </div>
                <div className={'notosans-regular font-12 text-left margin-top-20'}>
                  브랜드의 상황과 전략, 타겟 소비자의 라이프스타일과<br/>
                  트렌드에 기반한 최적의 접점에서 소비자의 주목을 끌고<br/>
                  생각과 행동을 바꾸는 다양한 브랜드 콘텐츠를 만들어냅니다.
                </div>
              </Fade>
            </div>
            <div className={'absolute'} style={{top: '280vw', right: '5vw'}} align={'right'}>
              <Fade direction={'right'}>
                <img style={{height: '40vw'}} src={require('../assets/images/service3_text3.png')}/>
                <div className={'notosans-bold font-18 text-right'} style={{marginTop: '3vw'}}>
                  휘닉스커뮤니케이션즈의 모든 커뮤니케이션은<br/>
                  소비자와의 긴밀한 관계 구축을 지향합니다.
                </div>
                <div className={'notosans-regular font-12 text-right margin-top-20'}>
                  광고를 통해 브랜드를 알리는 것에서 더 나아가,<br/>
                  브랜드를 직접 체험하고 브랜드와 유대감을 형성하게 하는<br/>
                  다양한 활동들을 전개하여 즉각적인 행동 유발과 함께<br/>
                  중장기적으로 브랜드에 대한 충성도를 강화합니다.
                </div>
              </Fade>
            </div>
            <div className={'absolute'} style={{top: '400vw', left: '5vw'}}>
              <Fade direction={'left'}>
                <img style={{height: '40vw'}} src={require('../assets/images/service3_text4.png')}/>
                <div className={'notosans-bold font-18 text-left'} style={{marginTop: '3vw'}}>
                  휘닉스커뮤니케이션즈의 솔루션은<br/>
                  늘 새로움을 추구합니다.
                </div>
                <div className={'notosans-regular font-12 text-left margin-top-20'}>
                  익숙한 광고 기술보다 혁신적인 광고 기술로<br/>
                  새로운 형태의 브랜드 콘텐츠를 만들어내고,<br/>
                  변화하는 미디어 환경과 시대적인 소비자의 선호에 맞춰<br/>
                  데이터 기반의 효율적인 커뮤니케이션을 실행합니다.
                </div>
              </Fade>
            </div>
          </div>

          <div className={'relative'} style={{marginTop: -5}}>
            <img className={'width-100'} src={require('../assets/images/mobile/mobile_service_5_bg.png')}/>
            <div className={'absolute'} style={{top: '30vw', left: '5vw'}}>
              <Fade direction={'left'}>
                <img style={{width: '100vw'}} src={require('../assets/images/service4_text.png')}/>
                <div className={'white font-12 notosans-regular margin-top-40'}>
                  휘닉스커뮤니케이션즈의 크리에이티브에는 제한된 영역은 없습니다.<br/>
                  브랜드 콘텐츠부터 소비자 경험 마케팅,<br/>
                  디지털 캠페인에 미디어 서비스까지<br/>
                  브랜드 성공을 위해 경계를 넘나들며<br/>
                  다양하면서도 통합된 캠페인을 실행합니다.
                </div>
              </Fade>
            </div>
            <div className={'absolute'} style={{bottom: '12vw', left: '1.5vw'}} align={'right'}>
              <Tags/>
              {/*<Fade direction={'up'}>*/}
              {/*  <img style={{width: '95%'}} src={require('../assets/images/mobile/service4_tags.png')}/>*/}
              {/*</Fade>*/}
            </div>
            <div className={'absolute'} style={{top: '90vw', right: '0vw'}} align={'right'}>
              <Fade direction={'right'}>
                <img style={{width: '50%'}} src={require('../assets/images/mobile/mobile_service4_x.png')}/>
              </Fade>
            </div>
          </div>
        </div>
      }
      <div style={{marginTop: -5}}>
        <Footer/>
      </div>
    </div>
  )
}
